import React from "react"
import {HeadFC, PageProps, graphql} from "gatsby"
import Seo from "../components/ui/seo/Seo";
import HorizontalLayout from "../components/ui/layout/HorizontalLayout";
import Header from "../sections/shared/header/Header";
import PinkOctoberBookContent from "../sections/pinkOctoberBook/PinkOctoberBookContent";

const PinkOctoberBookPage: React.FC<PageProps> = ({location}) => (
    <>
        <main>
            <HorizontalLayout>
                <div style={{backgroundColor: '#FFF'}}>
                    <Header />
                </div>
                <PinkOctoberBookContent />
            </HorizontalLayout>
        </main>
    </>
);

export default PinkOctoberBookPage;

export const Head: HeadFC = ({location}) => (
    <Seo
        title='Livret Octobre rose'
        description="Découvrez notre dernier livret sur Octobre Rose et la santé environnementale ! Entre conseils et astuces, vous aurez les cartes en main pour engager vos équipes autour du cancer du sein et du dépistage !"
        image="https://res.cloudinary.com/energic/image/upload/v1751537313/meta_image_octobre_rose_esjqea.jpg"
        pathname={location.pathname}
    />
);

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
